module.exports = "<div class=\"loader\" [id]=\"id\">\n    <mat-spinner></mat-spinner>\n</div>"